import React from 'react';
import PropTypes from 'prop-types';
import { SectionWrapper } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { resolveRenderField } from '../../../../../services/cms/HtmlResolver';

export const RoutineCareSection = ({ routineCareContent, dynamicValue, dropdownField, forceExpand, cmsTags }) => {
  return (
    <div className="routineCareSection">
      <SectionWrapper
        key="routineCare"
        customCssClass="accordionButtonClass"
        headerButtonCustomLabel="Routine care"
        isOpen={forceExpand || false}
      >
        {routineCareContent?.map(({ fullKey, field }) => (
          <React.Fragment key={fullKey}>
            {resolveRenderField({ field, key: fullKey, dynamicValue, dropdownField, cmsTags })}
          </React.Fragment>
        ))}
      </SectionWrapper>
    </div>
  );
};

RoutineCareSection.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  routineCareContent: PropTypes.array,
  dynamicValue: PropTypes.object,
  dropdownField: PropTypes.object,
  forceExpand: PropTypes.bool,
  cmsTags: PropTypes.object
  /* eslint-disable react/forbid-prop-types */
};
